"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TableSummarizerAggregate = exports.NewsSource = exports.RunType = exports.BlockType_Processor = void 0;
var BlockType_Processor;
(function (BlockType_Processor) {
    BlockType_Processor["text_slicer"] = "text_slicer";
    BlockType_Processor["text_chunker"] = "text_chunker";
    BlockType_Processor["text_to_text_ai"] = "text_to_text_ai";
    BlockType_Processor["texts_to_text_ai"] = "texts_to_text_ai";
    BlockType_Processor["search_google_with_ai"] = "search_google_with_ai";
    BlockType_Processor["search_wikipedia_with_ai"] = "search_wikipedia_with_ai";
    BlockType_Processor["text_to_json_ai"] = "text_to_json_ai";
    BlockType_Processor["text_file_loader"] = "text_file_loader";
    BlockType_Processor["xlsx_file_loader"] = "xlsx_file_loader";
    BlockType_Processor["table_summarizer"] = "table_summarizer";
    BlockType_Processor["file_pdf_extractor"] = "file_pdf_extractor";
    BlockType_Processor["google_document_ai"] = "google_document_ai";
    BlockType_Processor["api_google_news"] = "api_google_news";
    BlockType_Processor["api_google_news_multi"] = "api_google_news_multi";
    BlockType_Processor["triggered_text_document"] = "triggered_text_document";
    BlockType_Processor["triggered_get_business_news"] = "triggered_get_business_news";
    BlockType_Processor["audio_chunker"] = "audio_chunker";
    BlockType_Processor["audio_compressor"] = "audio_compressor";
    BlockType_Processor["audio_to_text_ai"] = "audio_to_text_ai";
    BlockType_Processor["text_merger"] = "text_merger";
    // document from another block
    BlockType_Processor["texts_merger"] = "texts_merger";
    // with one document from another block
    BlockType_Processor["link_youtube_extractor"] = "link_youtube_extractor";
    BlockType_Processor["text_splitter"] = "text_splitter";
    BlockType_Processor["send_email"] = "send_email";
})(BlockType_Processor || (exports.BlockType_Processor = BlockType_Processor = {}));
var RunType;
(function (RunType) {
    RunType["immediate"] = "immediate";
    RunType["batch"] = "batch";
    RunType["queued"] = "queued";
})(RunType || (exports.RunType = RunType = {}));
var NewsSource;
(function (NewsSource) {
    NewsSource["google"] = "google";
    NewsSource["naver"] = "naver";
})(NewsSource || (exports.NewsSource = NewsSource = {}));
var TableSummarizerAggregate;
(function (TableSummarizerAggregate) {
    TableSummarizerAggregate["sum"] = "sum";
    TableSummarizerAggregate["average"] = "average";
    TableSummarizerAggregate["count"] = "count";
    TableSummarizerAggregate["max"] = "max";
    TableSummarizerAggregate["min"] = "min";
})(TableSummarizerAggregate || (exports.TableSummarizerAggregate = TableSummarizerAggregate = {}));
